import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AddAnime from "./pages/AddAnime";
import AnimeGuess from "./pages/AnimeGuess";
import Header from "./components/Header";
import { Analytics } from "@vercel/analytics/react";

function App() {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      return savedTheme;
    }
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      return "dark";
    }
    return "light";
  });

  useEffect(() => {
    document.body.className = theme;
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  return (
    <div className={theme}>
      <Analytics />
      <Router>
        <Header currentTheme={theme} toggleTheme={toggleTheme} />
        <Routes>
          <Route path="/" element={<AddAnime />} />
          <Route path="/guesstheanime" element={<AnimeGuess />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
